import React, { useState, useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import {
    UserOutlined,
    ArrowLeftOutlined,
    EditOutlined,
    DeleteOutlined,
} from "@ant-design/icons";
import {
    Button,
    Card,
    Tabs,
    Select,
    Form,
    message,
    Input,
    Upload,
    Tag,
    Row,
    Col,
    Divider,
    Drawer,
    Table,
    Popconfirm,
} from "antd";
import LeaveService from "../../Services/Manage/LeaveService";
import AddSalary from "./AddSalary";
import DocumentationUpload from "./DocumentationUpload";
import GenerateOfferLetter from "./GenerateOfferLetter";
import BreakType from "./BreakType";
import AttendanceReport from "./AttendanceReport";
import SalaryIssues from "./SalaryIssues";
import { useNavigate } from "react-router-dom"; // add this line


const { Option } = Select;
const { TextArea } = Input;
const { TabPane } = Tabs;

function AllActions() {
    const navigate = useNavigate();

    // Map URL paths to tab keys
    const pathToKey = {
        "/workforce-management/actions/add-leave": "1",
        "/workforce-management/actions/add-salary": "2",
        "/workforce-management/actions/documentation-upload": "3",
        "/workforce-management/actions/generate-offerletter": "4",
        "/workforce-management/actions/attendance-report": "5",
        "/workforce-management/actions/salary-issues": "6",
    };

    // Map tab keys to URL paths
    const keyToPath = Object.fromEntries(
        Object.entries(pathToKey).map(([k, v]) => [v, k])
    );

    // Determine the current tab based on URL
    const currentTab = pathToKey[window.location.pathname] || "1";

    const location = useLocation();
    const {
        userId,
        user_id,
        addedBy,
        departmentId,
        name,
        department,
        phone,
        status,
    } = location.state || {};
    console.log("Propsqwqwq received: ", location.state);

    const [leaveTypes, setLeaveTypes] = useState([]);
    const [loadingLeaveTypes, setLoadingLeaveTypes] = useState(false);
    const [submittedLeaveTypes, setSubmittedLeaveTypes] = useState([]);
    const [drawerVisible, setDrawerVisible] = useState(false);
    const [submittedSalaries, setSubmittedSalaries] = useState([]);
    const [editingSalaryIndex, setEditingSalaryIndex] = useState(null);
    const [uploadedDocs, setUploadedDocs] = useState([]);
    const [fileTitles, setFileTitles] = useState({});
    const [submittedDocs, setSubmittedDocs] = useState([]);

    const [form] = Form.useForm();
    const [salaryForm] = Form.useForm();
    const [docForm] = Form.useForm();

    function parseLeaveTypeId(leaveTypeIdString) {
        if (!leaveTypeIdString) return [];
        try {
            const parsed = JSON.parse(leaveTypeIdString);
            if (Array.isArray(parsed)) return parsed;
        } catch { }
        const matches = leaveTypeIdString.match(/\d+/g);
        return matches || [];
    }

    useEffect(() => {
        const fetchData = async () => {
            setLoadingLeaveTypes(true);
            try {
                const res = await LeaveService.getLeaveType();
                if (res?.status && Array.isArray(res.data)) {
                    setLeaveTypes(res.data); // Master list of leave types
                } else {
                    message.error("Failed to load leave types.");
                    return;
                }

                if (user_id) {
                    const assigned = await LeaveService.getEmployeeLeaveTypes(user_id);
                    const assignedLeaveData = assigned.data
                        ? Array.isArray(assigned.data)
                            ? assigned.data
                            : [assigned.data]
                        : [];

                    if (assigned?.status && assignedLeaveData.length > 0) {

                        const assignedIds = assignedLeaveData.flatMap(item => {
                            const ids = typeof item.leave_type_id === 'string'
                                ? item.leave_type_id.split(',').map(id => id.trim())
                                : [item.leave_type_id.toString()];
                            return ids;
                        });

                        setSubmittedLeaveTypes(assignedIds);
                        form.setFieldsValue({ leaveType: assignedIds });
                    } else {
                        message.warning("No assigned leave types found.");
                        setSubmittedLeaveTypes([]);
                        form.setFieldsValue({ leaveType: [] });
                    }
                }
            } catch (error) {
                console.error("Fetch error:", error);
                message.error("Error loading leave types.");
            } finally {
                setLoadingLeaveTypes(false);
            }
        };

        fetchData();
    }, [user_id]);



    const onLeaveSubmit = async (values) => {
        const selectedLeaveTypeIds = values.leaveType;

        try {
            const payload = {
                leave_type_id: selectedLeaveTypeIds.join(","),
                added_by: addedBy,
            };


            if (submittedLeaveTypes.length > 0) {

                const res = await LeaveService.updateEmployeeLeaveTypes(user_id, payload);
                if (!res.status) throw new Error("Update failed");

                message.success("Leave types updated!");
            } else {

                for (let leaveTypeId of selectedLeaveTypeIds) {
                    const createPayload = {
                        emp_id: user_id,
                        leave_type_id: leaveTypeId,
                        added_by: addedBy,
                    };
                    const res = await LeaveService.createEmployeeLeaveType(createPayload);
                    if (!res.status) throw new Error("Create failed");
                }
                message.success("Leave types added!");
            }

            setSubmittedLeaveTypes(selectedLeaveTypeIds);
        } catch (err) {
            console.error(err);
            message.error("Failed to submit leave types.");
        }
    };





    const openEditDrawer = (index) => {
        const salary = submittedSalaries[index];
        salaryForm.setFieldsValue(salary);
        setEditingSalaryIndex(index);
        setDrawerVisible(true);
    };

    const onSalaryFinish = (values) => {
        if (editingSalaryIndex !== null) {
            const updatedSalaries = [...submittedSalaries];
            updatedSalaries[editingSalaryIndex] = values;
            setSubmittedSalaries(updatedSalaries);
            message.success("Salary details updated!");
        } else {
            setSubmittedSalaries((prev) => [...prev, values]);
            message.success("Salary details submitted!");
        }
        setDrawerVisible(false);
        salaryForm.resetFields();
        setEditingSalaryIndex(null);
    };

    const onDeleteSalary = (index) => {
        const newSalaries = submittedSalaries.filter((_, i) => i !== index);
        setSubmittedSalaries(newSalaries);
        message.success("Salary details deleted!");
    };

    const normFile = (e) => {
        if (Array.isArray(e)) {
            return e;
        }
        return e && e.fileList;
    };

    const handleFilesChange = ({ fileList }) => {
        setUploadedDocs(fileList);
    };

    const onDocFinish = () => {
        if (uploadedDocs.length === 0) {
            message.error("Please upload at least one file.");
            return;
        }

        const formattedDocs = uploadedDocs.map((file) => ({
            name: file.name,
            title: fileTitles[file.uid] || "",
            user_id,
            departmentId,
            addedBy,
            file: file.originFileObj,
        }));

        setSubmittedDocs(formattedDocs);
        setUploadedDocs([]);
        setFileTitles({});
        docForm.resetFields();
        message.success("Documentation uploaded!");
    };

    const salaryColumns = [
        { title: "Salary Type", dataIndex: "salaryType", key: "salaryType" },
        { title: "Salary Amount", dataIndex: "ctc", key: "ctc" },
        { title: "Working Hours", dataIndex: "workingHours", key: "workingHours" },
        { title: "Description", dataIndex: "description", key: "description" },
        { title: "Note", dataIndex: "note", key: "note" },
        {
            title: "Action",
            key: "action",
            render: (_, record, index) => (
                <>
                    <Button
                        type="link"
                        icon={<EditOutlined style={{ fontSize: 18 }} />}
                        onClick={() => openEditDrawer(index)}
                        style={{
                            marginRight: 8,
                            border: '1px solid #d9d9d9',
                            borderRadius: 6,
                            padding: '4px 8px',
                        }}
                    />
                    <Popconfirm
                        title="Are you sure to delete this salary detail?"
                        onConfirm={() => onDeleteSalary(index)}
                        okText="Yes"
                        cancelText="No"
                    >
                        <Button type="link" danger icon={<DeleteOutlined style={{ fontSize: 18 }} />}
                            style={{
                                marginRight: 8,
                                border: '1px solid #d9d9d9',
                                borderRadius: 6,
                                padding: '4px 8px',
                            }}

                        />
                    </Popconfirm>
                </>
            ),
        },
    ];

    return (
        <Card>
            <Card
                style={{
                    marginBottom: 24,
                    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                    borderRadius: 12,
                    padding: "24px 32px",
                    background: "#fafafa",
                }}
            >
                <Row align="middle" gutter={16} style={{ marginBottom: 20 }}>
                    <Col>
                        <Link to="/workforce-management">
                            <ArrowLeftOutlined
                                style={{ fontSize: 22, color: "#1890ff", cursor: "pointer" }}
                                title="Back to Workforce Management"
                            />
                        </Link>
                    </Col>
                    <Col>
                        <UserOutlined
                            style={{
                                fontSize: 34,
                                color: "#1890ff",
                                backgroundColor: "#e6f7ff",
                                borderRadius: "50%",
                                padding: 8,
                            }}
                        />
                    </Col>
                    <Col>
                        <h2 style={{ margin: 0, fontWeight: "700", color: "#001529", fontSize: "17px" }}>
                            User Profile Overview
                        </h2>
                    </Col>
                </Row>

                <Divider style={{ marginTop: 0, marginBottom: 24 }} />

                <Row
                    align="middle"
                    justify="space-between"
                    style={{ fontSize: 16, color: "#595959", flexWrap: "nowrap", gap: 24 }}
                >
                    <Col>
                        <strong>Name:</strong>{" "}
                        <span style={{ fontWeight: 600, fontSize: 16, color: "#000" }}>{name || "N/A"}</span>
                    </Col>

                    <Col>
                        <strong>UID:</strong>{" "}
                        <span style={{ fontWeight: 600, fontSize: 16, color: "#000" }}>{user_id || "N/A"}</span>
                    </Col>

                    <Col>
                        <strong>Department:</strong>{" "}
                        <span style={{ fontWeight: 600, fontSize: 16, color: "#000" }}>{department || "N/A"}</span>
                    </Col>

                    <Col>
                        <strong>Phone No:</strong>{" "}
                        <span style={{ fontWeight: 600, fontSize: 16, color: "#000" }}>{phone || "N/A"}</span>
                    </Col>

                    <Col>
                        <strong>Status:</strong>{" "}
                        <Tag
                            color={status === "Active" ? "green" : "volcano"}
                            style={{ fontWeight: 600, fontSize: 15, padding: "2px 10px" }}
                        >
                            {status || "Unknown"}
                        </Tag>
                    </Col>
                </Row>
            </Card>

            <Tabs
                activeKey={currentTab}
                type="card"
                onChange={(key) =>
                    navigate(keyToPath[key], {
                        state: { userId, user_id, addedBy, departmentId, name, department, phone, status }
                    })
                }
            >


                <TabPane tab="Add Leave Type" key="1">
                    <Card title="Leave Types" >
                        <Form
                            layout="vertical"
                            form={form}
                            onFinish={onLeaveSubmit}
                            initialValues={{ leaveType: [] }}
                        >


                            <Form.Item
                                label="Add Leave Type(s)"
                                name="leaveType"
                                rules={[{ required: true, message: "Please select leave type(s)" }]}
                            >
                                <Select
                                    mode="multiple"
                                    placeholder="Select leave type(s)"
                                    loading={loadingLeaveTypes}
                                    allowClear
                                    showSearch
                                    optionFilterProp="children"
                                    style={{ width: 300 }}
                                >
                                    {leaveTypes.map((lt) => (
                                        <Option key={lt.id.toString()} value={lt.id.toString()}>
                                            {lt.leave_type}
                                        </Option>
                                    ))}
                                </Select>

                            </Form.Item>
                            <Form.Item>
                                <Button type="primary" htmlType="submit">
                                    Submit
                                </Button>
                            </Form.Item>
                            {submittedLeaveTypes.length > 0 && leaveTypes.length > 0 ? (
                                <Card
                                    size="small"
                                    style={{
                                        marginTop: 16,
                                        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                                        borderRadius: 8,
                                        width: 300,
                                    }}
                                    title="Submitted Leave Types"
                                >
                                    {submittedLeaveTypes.map((id) => {
                                        const leaveType = leaveTypes.find((lt) => lt.id.toString() === id);
                                        return (
                                            <Tag key={id} color="blue" style={{ marginBottom: 8 }}>
                                                {leaveType ? leaveType.leave_type : `Type ID: ${id}`}
                                            </Tag>
                                        );
                                    })}
                                </Card>
                            ) : (
                                <p style={{ marginTop: 16, color: "#999" }}>
                                    No leave types submitted yet.
                                </p>
                            )}



                        </Form>
                    </Card>
                </TabPane>

                <TabPane tab="Add Salary" key="2">
                    <AddSalary user_id={user_id} departmentId={departmentId} addedBy={addedBy} />
                </TabPane>

                <TabPane tab="Documentation Upload" key="3">

                    <DocumentationUpload user_id={user_id} departmentId={departmentId} addedBy={addedBy} />
                </TabPane>

                <TabPane tab="Generate OfferLetter" key="4">

                    <GenerateOfferLetter user_id={user_id} name={name} departmentId={departmentId} addedBy={addedBy} department={department} />
                </TabPane>

                <TabPane tab="Attendance Report" key="5">
                    <AttendanceReport
                        user_id={user_id}
                        name={name}
                        departmentId={departmentId}
                        addedBy={addedBy}
                        department={department}
                        phone={phone}
                        status={status}
                    />
                </TabPane>



                <TabPane tab="Salary Issues" key="6">
                    <SalaryIssues
                        user_id={user_id}
                        name={name}
                        departmentId={departmentId}
                        addedBy={addedBy}
                        department={department}
                        phone={phone}
                        status={status}
                    />
                </TabPane>

            </Tabs>
        </Card>
    );
}

export default AllActions;
